const resolveApiBase = () => {
  const envBase =
    process.env.REACT_APP_API_BASE_URL ||
    process.env.REACT_APP_API_URL ||
    '';
  if (typeof window === 'undefined') return envBase || '';
  const fallback = window.location.origin || '';
  if (!envBase) return fallback;
  return envBase;
};

const API_BASE = resolveApiBase().replace(/\/$/, '');

const safeFetch = async (...args) => {
  try {
    return await fetch(...args);
  } catch (_) {
    throw new Error('Unable to reach the API. Check that the backend is running.');
  }
};

const withCustomerAuthFallback = async (suffix, init) => {
  return safeFetch(`${API_BASE}/api/auth/customer${suffix}`, init);
};

const handle = async (res) => {
  if (!res) throw new Error('Unable to reach the API. Check that the backend is running.');
  const text = await res.text();
  let data = {};
  if (text) {
    try {
      data = JSON.parse(text);
    } catch (_) {
      data = { message: text };
    }
  }
  if (!res.ok) {
    throw new Error(data?.message || 'Request failed');
  }
  return data;
};

export const signupCustomer = async (payload) => {
  const res = await withCustomerAuthFallback('/signup', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(payload),
  });
  return handle(res);
};

export const loginCustomer = async (payload) => {
  const res = await withCustomerAuthFallback('/login', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(payload),
  });
  return handle(res);
};

export const requestCustomerOtp = async (payload) => {
  const res = await withCustomerAuthFallback('/otp/request', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(payload),
  });
  return handle(res);
};

export const verifyCustomerOtp = async (payload) => {
  const res = await withCustomerAuthFallback('/otp/verify', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(payload),
  });
  return handle(res);
};

export const refreshCustomerToken = async () => {
  const res = await withCustomerAuthFallback('/refresh', {
    method: 'POST',
    credentials: 'include',
  });
  return handle(res);
};

export const fetchCustomerProfile = async (accessToken) => {
  const res = await withCustomerAuthFallback('/me', {
    headers: { Authorization: `Bearer ${accessToken}` },
    credentials: 'include',
  });
  return handle(res);
};

export const logoutCustomer = async (accessToken) => {
  const res = await withCustomerAuthFallback('/logout', {
    method: 'POST',
    headers: { Authorization: `Bearer ${accessToken}` },
    credentials: 'include',
  });
  await handle(res);
};

export const getCustomerBookings = async (accessToken, { page = 1, limit = 10 } = {}) => {
  const params = new URLSearchParams({ page, limit });
  const res = await fetch(`${API_BASE}/api/customer/bookings?${params.toString()}`, {
    headers: { Authorization: `Bearer ${accessToken}` },
    credentials: 'include',
  });
  return handle(res);
};

export const getCustomerBooking = async (accessToken, id) => {
  const res = await fetch(`${API_BASE}/api/customer/bookings/${id}`, {
    headers: { Authorization: `Bearer ${accessToken}` },
    credentials: 'include',
  });
  return handle(res);
};

export const updateCustomerProfile = async (accessToken, payload) => {
  const res = await fetch(`${API_BASE}/api/customer/profile`, {
    method: 'PATCH',
    headers: { Authorization: `Bearer ${accessToken}`, 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(payload),
  });
  return handle(res);
};


